import cn from 'clsx';
import { forwardRef, HTMLAttributes, useContext, useMemo } from 'react';

import AccordionContext from '../context';

import s from './AccordionPanel.module.scss';

export type AccordionPanelProps = HTMLAttributes<HTMLDivElement>;

const AccordionPanel = forwardRef<HTMLDivElement, AccordionPanelProps>(({ className, ...rest }, ref) => {
  const AccordionPanelContext = useContext(AccordionContext);

  const style = useMemo(() => {
    return AccordionPanelContext?.isExpanded ? s.expanded : s.collapsed;
  }, [AccordionPanelContext?.isExpanded]);

  return <div className={cn(style, className)} ref={ref} {...rest} />;
});

export default AccordionPanel;
